import React from "react";

export const Sidebar = () => {
  return (
  
	
	<div class="service-sidebar js-sticky">
          <div class="service-widget">
            <h5 class="widget-title">All Services</h5>
            <ul class="service-menu list-unstyled mb-0">
              <li class="active">
                <a href="">SEO (Search Engine Optimization)</a>
              </li>
              <li>
                <a href="">AEO (Answer Engine Optimization)</a>
              </li>
              <li>
                <a href="">GEO (Geographical SEO)</a>
              </li>
              <li>
                <a href="">Digital Marketing Solutions</a>
              </li>
              
            </ul>
          </div>
          <div class="service-widget p-0">
            <div class="contact-widget grediant-bg3 rounded">
              <h3 class="mb-2 text-white">Contact us for help</h3>
              <p class="text-white">Get in touch and let us know how we can help touch as soon as possible.</p>
              <a class="themeht-btn primary-btn" href="contact.html">
                <span>Work With Us</span>
                <i class="bi bi-arrow-right"></i>
              </a>
              <img class="img-fluid mt-5" src="./assets/images/contact-bg.png" alt="" />
            </div>
          </div>
        </div>
	
	
	
  );
};
